import React from "react";
import {change,  reducer as formReducer, reduxForm} from "redux-form";
import {combineReducers, createStore} from "redux";
import {Provider } from "react-redux";
import {RYIFinish, RYIForm} from "../components/BaseForm";
import "../index.css";
import FormHandlers from "../FormHandlers";
import "./index.css";
import {YourDetails} from "../components/YourDetails";
import oneSvg from "../images/1.svg"
import {RYIValidator, transformVehicle, validatePostcode} from "../util/Validators";
import {RegisterYourInterestDirectCall} from "../components/DTMDirectCalls";

const rootReducer = combineReducers({
    form: formReducer,
});

const store = createStore(
    rootReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

const SUBMISSION_URL = process.env.REACT_APP_RYI_URL;
const VERSION = process.env.REACT_APP_VERSION_ID;

function parseParamsAndAction(location, action){
    const params = location.search.replace("?" , "").split("&");
    params.forEach(param => {
        const a = param.split("=");
        const value = decodeURIComponent(a[1]).replace(  /-/g , " ");
        action(a[0], value);
    });
}


function App(props) {
    const {brand, formName, config} = props;
    const handlers = FormHandlers(SUBMISSION_URL, brand, config , {
        onSubmitSuccess: async function (results, dispatch, props) {
            const {formValues} = results;
            if (formValues) {
                const {marketingOptIn,postcode, vehicle , year , digitalData , email } = formValues;
                RegisterYourInterestDirectCall(brand, config , true).complete(
                    vehicle , year || config[transformVehicle(vehicle)].year ,
                    postcode, marketingOptIn, email , digitalData , window);
            }
            dispatch(change(formName, 'completed', true));
            dispatch(change(formName, 'response', results));
            setTimeout(() => {
                if (window.parentIFrame) {
                    window.parentIFrame.moveToAnchor("#top");
                }
            }, 500);

        }
    });

    const searchParams = new URLSearchParams(window.location.search);
    const urlVehicle = searchParams.get("vehicle");

    RegisterYourInterestDirectCall(brand, config , true).start(urlVehicle);

    const asyncValidateWrapper = (values, dispatch, formProps, blurredField) => {
        if (brand.value !== "leap") {
          return validatePostcode(values, dispatch, formProps, blurredField);
        } else {
          return new Promise((resolve) => {
            dispatch(change(formName, 'dealer', {}));
            dispatch(change(formName, 'dealerfound', true));
            resolve();
          });
        }
    };


    return (
        <Provider store={store}>
            <a name="top" data-version={VERSION}/>
            <div className={`${brand.value} container-fluid pl-0 pr-0`}>
                <ConfigValidator config={config}>

                <RYIForm formName={formName || "fca-ryi"} loader={props.loader}
                         componentWillMountCallback={async (p) => {
                             parseParamsAndAction(window.location, (name , value ) => {
                                 p.dispatch(change(formName ,name , value))
                             });
                             return {}
                         }}
                         optionalConfig={{
                             asyncChangeFields : ['postcode'],
                             //asyncValidate :  validatePostcode,
                             asyncValidate: asyncValidateWrapper,
                             validate: (values) => {
                                 return RYIValidator(values);
                             },
                             initialValues: {
                                 brand: brand,
                                 'firstname': "",
                                 'lastname': "",
                                 'postcode': '',
                                 'email': '',
                                 'phone': '',
                                 'completed': false,
                                 'brandConfig': config,
                                 'marketingOptIn': true,
                                 'vehicle' : "",
                                 'eVar39': '',
                                 'GACLIENTID': '',
                                 'invalidConfig' : true,
                             }
                         }}
                         isFormValid={(props) => {
                             const {formValues} = props;
                             if (formValues !== undefined) {
                                 const {dealerfound , postcode , dealer } = formValues;
                                 return /^[0-9]{4}$/.test(postcode) && dealerfound && dealer
                             } else {
                                 return false;
                             }
                         }}

                         onSubmit={handlers.onSubmit}
                         onSubmitFail={handlers.onSubmitFail}
                         onSubmitSuccess={handlers.onSubmitSuccess}>
                        <YourDetails formName={formName} icon={oneSvg} displayStep={false}/>
                </RYIForm>
                </ConfigValidator>


                <RYIFinish formName={formName} config={config} brand={brand} data={"response"}/>
            </div>
        </Provider>
    )
}

function ConfigValidator(props){

    let invalidConfig = true;
    const configMap = Object.fromEntries(
        Object.entries(props.config).map(([k, v]) => [k.toLowerCase(), v])
      );
    parseParamsAndAction(window.location, (name, value) => {
        if(name === 'vehicle' && configMap[value.toLowerCase()] !== undefined){
            invalidConfig = false;
        }
    });

    if(invalidConfig){
        return <div className={'col-12 text-center'}>
            <h1>Invalid page configuration</h1>
            <p>Please make sure vehicle specified is allowed</p>
        </div>
    }
    else{
        return props.children
    }
}

export default App;
